// extracted by mini-css-extract-plugin
export default {"container":"_38M_KlYjanIm3sZLf657aq","content":"_3Fecs9NIBcJVD7wTDtYO0W"};